import {isValidDate} from '../GeneralValidators';
import { getAgeFromCNP } from '../../general/Utilities';

export const AmountZeroField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    } else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value < 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const ValidDate = (value, param) => {
  
    const { minAge, maxAge} = param;
    if (value == ''){
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    }

    let validData = isValidDate(value);
    if (!validData) {
        return {
            status: false,
            msg: 'Dată invalidă'
        }
    }

    const {day, month, year} = validData;

    if (minAge || maxAge) {
        let currentDate = new Date();
        let birthDate = new Date(year, month-1, day);
        if (currentDate < birthDate) {
            return {
                status: false,
                msg: 'Ai venit din viitor?'
            }
        }
        let ageDate = new Date(new Date() - new Date(year, month-1, day) ); // miliseconds from epoch
        let years =  Math.abs(ageDate.getUTCFullYear() - 1970);
        if (minAge) {
            if (years < minAge) {
                return {
                    status: false,
                    msg: 'Vârsta minimă este de '+ minAge + ' ani'
                }
            }
        }
        if (maxAge) {
            if (years > maxAge) {
                return {
                    status: false,
                    msg: 'Vârsta maximă este de '+ maxAge + ' ani'
                }
            }
        }
        
    }

    return {
        status: true,
        msg: ''
    }

}

export const validateEligibilityData = (profile) => {
    if (!profile.hasOwnProperty('income') || !Number.isInteger(profile.income) || profile.income<= 0) {
        return false;
    }
    if (!profile.hasOwnProperty('totalEmployment') || !Number.isInteger(profile.totalEmployment) || profile.totalEmployment < 0) {
        return false;
    }
    if (!profile.hasOwnProperty('currentEmployment') || !Number.isInteger(profile.currentEmployment) || profile.currentEmployment < 0) {
        return false;
    }
    if (!profile.hasOwnProperty('age') || !Number.isInteger(profile.age) || profile.age < 18 || profile.age > 100 ) {
        return false;
    }
    if (!profile.hasOwnProperty('currentPayments') || !Number.isInteger(profile.currentPayments) || profile.currentPayments < 0 ) {
        return false;
    }
    if (!profile.hasOwnProperty('birthdate') ||  !(isValidDate(profile.birthdate)) ) {
        return false;
    }

    return true;
}

export const AmountOptionalField = (value) => {
    if (value == '') {
        return {
            status: true,
            msg: ''
        }
    } else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value <= 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const isInvalidCNP = (value) => {
    if (value.length != 13) { 
        return  'CNP trebuie sa aiba 13 cifre';
    }

    let suma = 0;
    let sirdeverif = new Array();
    sirdeverif[0] = 2;
    sirdeverif[1] = 7;
    sirdeverif[2] = 9;
    sirdeverif[3] = 1;
    sirdeverif[4] = 4;
    sirdeverif[5] = 6;
    sirdeverif[6] = 3;
    sirdeverif[7] = 5;
    sirdeverif[8] = 8;
    sirdeverif[9] = 2;
    sirdeverif[10] = 7;
    sirdeverif[11] = 9;

    var anum=/(^\d+$)|(^\d+\.\d+$)/;
    let testresult;
    if (anum.test(value)){
            testresult = true;
            for (let i=0; i<sirdeverif.length; i++){
                suma = suma + (value.substring(i,i+1) * sirdeverif[i]);
            }
            suma = suma%11;
            let an = parseInt(value.substring(1,3));
            var sex = parseInt(value.substring(0,1));
            switch( sex ) {
                case 1  : case 2 : { an += 1900; } break;
                case 3  : case 4 : { an += 1800; } break;
                case 5  : case 6 : { an += 2000; } break;
                case 7  : case 8 : case 9 : { an += 2000; if( an > ( parseInt( new Date().getYear() , 10 ) - 14 ) ) { an -= 100; } } break;
                default : { 
                    return  'CNP incorect'; 
                }
            }
            
            if (((suma==value.substring(12,13))|| (suma/10==value.substring(12,13)))) {
                testresult = true;
            } else {
                return  'CNP incorect'; 
            }
    }
    else {
        return  'CNP incorect'; 
    }

    return false;
}

export const CNPFieldValidator = (value, param = { minAge:null, maxAge:null, provider: null} ) => {
    const {minAge, maxAge, provider} = param;
    let error = isInvalidCNP(value);
    if (error) {
        return {
            status: false,
            msg: error,
        }
    }

    let age = getAgeFromCNP(value);

    if (provider) {
        switch(provider) {
            case 'Telekom Banking':
                if (age<22) {
                    return {
                        status: false,
                        msg: `Vârsta minimă este 22 ani`,
                    }
                }
        }
    } 

    if (minAge || maxAge) {
        if (minAge && age<minAge) {
            return {
                status: false,
                msg: `Vârsta minimă este ${minAge} ani`,
            }
        }
        if (maxAge && age>maxAge) {
            return {
                status: false,
                msg: `Vârsta maximă este ${maxAge} ani`,
            }
        }
    }

    return {
        status: true,
        msg: '',
    }
}

export const isInvalidCIF = (value) => {
    let cif;
    if (value.substring(0, 2).toUpperCase() == 'RO') {
        if (value.length > 12 || value.length<4) {
            return 'CIF invalid';
        }
        cif = value.substring(2);
    } else {
        if (value.length > 10 || value.length<2 ) {
            return 'CIF invalid';
        }
        cif = value;
    }

    if (isNaN(cif)) {
        return 'CIF invalid';
    }

    const testKey = '753217532';
    let reverseKey = testKey.split('').reverse().join(''); 
    let reverseCif = cif.split('').reverse().join('');
   
    let sum = 0;
    for (let i=1; i < reverseCif.length; i++) {
        sum +=  parseInt(reverseCif[i]) * parseInt (reverseKey[i-1]);
    }
    
    let check = (sum * 10) % 11;
    if (check == 10) check = 0;

    if (check == reverseCif[0]) {
        return false;
    }



    return 'CIF invalid';

}

export const CIFFieldValidator = (value ) => { 
    if (value == '') {
        return {
            status: false,
            msg: 'Completează cămpul'
        }
    }

    let error = isInvalidCIF(value); 
    if (error) {
        return {
            status: false,
            msg: error,
        }
    }

    return {
        status: true,
        msg: '',
    }
}



               
